module.exports = __webpack_public_path__ + "static/media/StephenAraka_resume.1e5ad36f.pdf";